import { DestroyRef, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ErrorService } from '@shared/services/error.service';
import { SubscriptionManager } from '@shared/services/subscription-manager.service';
import { filter } from 'rxjs/operators';
import { InstanceIdService } from '@shared/services/instance-id.service';

@Injectable({
  providedIn: 'root',
})
export class RoutingStateService {
  private instanceId: string;

  private history: string[] = [];

  constructor(
    private router: Router,
    private errorService: ErrorService,
    private destroyRef: DestroyRef,
    private subscriptionManager: SubscriptionManager,
    private instanceIdService: InstanceIdService
  ) {
    this.instanceId = this.instanceIdService.generateId();
    this.subscriptionManager.registerComponent(this.instanceId, this.destroyRef);
  }

  loadRouting(): void {
    this.subscriptionManager
      .createRequest(this.router.events, 'routerEvents', this.instanceId)
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe({
        next: ({ urlAfterRedirects }: NavigationEnd) => {
          this.history = [...this.history, urlAfterRedirects];
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  getPreviousUrl(): string {
    return this.history[this.history.length - 2] || '/';
  }

  clear() {
    this.history = [];
    this.subscriptionManager.cancelRequestsForComponent(this.instanceId);
  }
}
